import { gql } from '@apollo/client'

const EDIT_REFERRAL_SOURCE = gql`
  mutation EDIT_REFERRAL_SOURCE(
    $referralSource: ID!
    $name: String!
    $order: Int
    $color: String!
    $referralUrl: String
    $referralId: String
    $forceSubtype: Boolean!
    $showForPatients: Boolean!
  ) {
    editReferralSource(
      referralSource: $referralSource
      name: $name
      order: $order
      color: $color
      referralUrl: $referralUrl
      referralId: $referralId
      forceSubtype: $forceSubtype
      showForPatients: $showForPatients
    ) {
      id
      name
      order
      color
      referralUrl
      referralId
      forceSubtype
      forPatients
      forUsers
      showForPatients
      createdAt
      updatedAt
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
    }
  }
`

export default EDIT_REFERRAL_SOURCE
